import React from "react";
import {
  Flex,
  Text,
  Button,
  SimpleGrid,
  Box,
  Input,
  useToast,
  Spinner
} from "@chakra-ui/react";
import { ArrowBackIcon } from "@chakra-ui/icons";

import { database } from "../../firebase";

export default function Campaigns({ match }) {
  const [isPageLoading, setIsPageLoading] = React.useState(true);
  const toast = useToast();
  const [isLoading, setIsLoading] = React.useState(false);

  const [json, setJson] = React.useState({});

  React.useEffect(() => {
    database
      .collection("campaigns")
      .doc(match.params.id)
      .get()
      .then((snapshot) => {
        setJson(snapshot.data());
      })
      .finally(() => {
        setIsPageLoading(false);
      });
  }, []);

  console.log(json);

  return (
    <>
      <Flex
        display={isPageLoading ? "flex" : "none"}
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <Spinner color="blue.400" size="lg" thickness="4px" />
      </Flex>
      <Flex
        display={isPageLoading ? "none" : "flex"}
        flexDirection="column"
        alignItems={{ base: undefined, "2lg": "center" }}
      >
        <Flex width={{ base: "97vm", "2lg": "1200px" }} m="12px" mt="42px">
          <Button
            leftIcon={<ArrowBackIcon />}
            colorScheme="blue"
            onClick={() => {
              window.open("/main", "_top");
            }}
          >
            Back
          </Button>
        </Flex>
        <Flex width={{ base: "97vm", "2lg": "1200px" }} m="12px">
          <Text fontSize="21" fontWeight="bold">
            {json.camapignTitle}
          </Text>
        </Flex>

        <Flex
          width={{ base: "97vm", "2lg": "1200px" }}
          justifyContent="center"
          m="12px"
        >
          <SimpleGrid
            columns="2"
            spacing="7px"
            borderWidth="2px"
            borderRadius="lg"
            p="12px"
          >
            <Text>Job ID</Text>
            <Text>{match.params.id}</Text>
            <Text>Work Done</Text>
            <Text>
              {json.campaign_work_done}/{json.campaign_workers_need}
            </Text>
            <Text>Workers will earned</Text>
            <Text>{json.campaign_bid}</Text>
            <Text>Category</Text>
            <Text>
              {json.campaign_category} {">"} Rate OR Vote
            </Text>
            <Text>Job Level</Text>
            <Text>Starter</Text>
            <Text>Time to Rate</Text>
            <Text>{json.campaign_task_to_rate}</Text>
            <Text>Target Region</Text>
            <Text>{json.campaign_region}</Text>
          </SimpleGrid>
        </Flex>
        <Flex
          width={{ base: "97vm", "2lg": "1200px" }}
          flexDirection="column"
          alignItems="center"
          m="12px"
        >
          <Flex
            flexDirection="column"
            borderWidth="2px"
            borderRadius="lg"
            p="12px"
          >
            <Text>What is expected from workers?</Text>
            {isEmpty(json) === false
              ? Object.keys(json.campaign_steps)
                  .sort()
                  .map((key, index) => {
                    return Steps(key, index, json.campaign_steps[key]);
                  })
              : undefined}

            <Text mt="12px">Required proof that task was finished?</Text>
            {isEmpty(json) === false
              ? Object.keys(json.campaign_proofs)
                  // .slice(0)
                  // .reverse()
                  .sort()
                  .map((key, index) => {
                    return Proofs(key, index, json.campaign_proofs[key]);
                  })
              : undefined}
          </Flex>
          <Flex mt="12px">
            <Button
              isLoading={isLoading}
              colorScheme="blue"
              onClick={() => {
                setIsLoading(true);
                database
                  .collection("campaigns")
                  .doc(match.params.id)
                  .collection("submitted_tasks")
                  .add({
                    demo: "this is demo"
                  })
                  .finally(() => {
                    setIsLoading(false);
                    toast({
                      title: "Task Submitted.",
                      description: "Your task has been submitted successfully.",
                      status: "success",
                      duration: 3000,
                      isClosable: true
                    });
                    window.open("/main", "_top");
                  });
              }}
            >
              Submit
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </>
  );
}

function Proofs(key, index, json) {
  return (
    <>
      {/* {key} */}
      <Text ms="12px" mb="6px">
        {`${index + 1}. `}
        {json[`${key}Details`]}
      </Text>
      {json["type"] === "Screenshot" ? (
        <Button ms="12px" colorScheme="blue" width="80px">
          Upload
        </Button>
      ) : (
        <Input ms="12px" placeholder="Enter the value." w="320px" />
      )}
    </>
  );
}

function Steps(key, index, json) {
  return (
    <>
      <Text ms="12px">
        {`${index + 1}. `}
        {json}
      </Text>
    </>
  );
}

function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

// will only use worldmap because, astroworkers don't
// collect user's sex, age nor be record on that day
// how many tasks have been done, instead we record
// in total how many tasks have been done.

// before using toast don't forgot to import
// ThemeProvider, theme
